// Fetch packages for booking modal
export async function getPackages() {
  const res = await api.get('/api/packages');
  return res.data;
}
// api.js: Centralized axios instance using .env for baseURL
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  headers: { 'Content-Type': 'application/json' },
});

// attach token from localStorage on each request
api.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem('user');
    const user = raw ? JSON.parse(raw) : null;
    const token = user?.token || localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch (e) {
    // ignore
  }
  return config;
}, (err) => Promise.reject(err));

// Retry on 429 (rate limit) and some transient network errors with exponential backoff
const MAX_RETRIES = 3;
const RETRY_BASE_MS = 250;

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config || {};
    config.__retryCount = config.__retryCount || 0;

    const status = error.response?.status;
    const shouldRetry = (status === 429) || (!status && error.code && error.code !== 'ECONNABORTED');

    if (shouldRetry && config.__retryCount < MAX_RETRIES) {
      config.__retryCount += 1;
      const wait = Math.pow(2, config.__retryCount) * RETRY_BASE_MS;
      await sleep(wait);
      return api(config);
    }

    return Promise.reject(error);
  }
);

export default api;
